"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { TilesRoutedPage } from './deskUi/TilesRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function TilesSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={TilesRoutedPage} Loading={MsgDeskLoading} />
}
